var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[(_vm.$route.name!= 'login')?_c('Header'):_vm._e(),_c('router-view'),(_vm.$route.name!= 'login')?_c('Footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }